// Login Apis
global.userSignIn = global.API_ADMIN_URL+'adminWebLoginRequest/';
global.newUserAddBusiness = global.API_USER_URL+'userAddBusiness/';

global.adminProfileUpdate = global.API_ADMIN_URL+'adminProfileUpdate/';
global.adminPasswordUpdate = global.API_ADMIN_URL+'adminPasswordUpdate/';

global.adminStateList = global.API_ADMIN_URL+'adminStateList/';
global.adminCountryList = global.API_ADMIN_URL+'adminCountryList/';